import React from "react";
import InnerBody from "../components/InnerBody";
import RaisedButton from "../components/RaisedButton";
import Header from "../components/Header";
import TitleBar from "../components/TitleBar";

class Page404 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <Header
          title="Entschuldigung"
          showProjectsDropdown={false}
          showProfile={false}
        />
        <InnerBody isLoading={false} noSidebar>
          <TitleBar title="Fehler 404: Diese Seite ist nicht verfügbar">
            <RaisedButton
              label="Zurück"
              onClick={() => {
                this.props.history.goBack();
              }}
            />
          </TitleBar>
        </InnerBody>
      </div>
    );
  }
}

export default Page404;



// WEBPACK FOOTER //
// ./src/pages/Page404.js